// removed by extract-text-webpack-plugin
module.exports = {"BrandEngageChannel__Card--Dismissed":"BrandEngageChannel__Card--Dismissed","brandEngageChannelCardDismissed":"BrandEngageChannel__Card--Dismissed"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/brand-engage/BrandEngageChannel.scss
// module id = 737
// module chunks = 0